import Color from 'color'
import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { Size } from '@ocean/types/dist/appearance'
import { StyledUtils } from '@ocean/utils'

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export type StyledSsoLoginButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  disabled?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  size?: Size
  uppercase?: boolean
  hint?: string
}

type IconWrapperProps = {
  size?: Size
}

export const IconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  align-items: center;
  height: 28px;

  ${({ theme }) => `
    margin-right: ${theme.space.mobile.tiny};
  `}
`

export const SsoProviderImage = styled.img`
  height: 28px;
`

export const Button = styled.button<StyledSsoLoginButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  cursor: pointer;
  transition: background 0.2s ease;
  width: 100%;

  ${({ theme }) => `
    padding: ${theme.space.mobile.small} ${theme.space.mobile.large};
    border-radius: ${theme.borderRadius.base};
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.fontSize.desktop.h3};

    background: ${theme.color.oceanLight};
        color: ${theme.color.white};

        &:hover:not(:disabled) {
          background: ${Color(theme.color.oceanLight).darken(0.15).string()};
        }
  `}

  &:disabled {
    cursor: default;
    opacity: 0.75;
  }

  &:focus {
    outline: none;
  }

  ${({ theme, size }) =>
    StyledUtils.getSize('', size, {
      sm: `
        letter-spacing: 1.2px;
        text-transform: uppercase;
        font-family: ${theme.fontFamily.secondary};
        padding: ${theme.space.mobile.tiny};
        font-size: ${theme.fontSize.mobile.tiny};
      `,
    })}

  ${({ theme, size }) => media.sm`
    ${StyledUtils.getSize('', size, {
      sm: `
        padding: ${theme.space.desktop.tiny};
        font-size: ${theme.fontSize.desktop.tiny};
      `,
    })}
  `}
`
